export function getGrowthIndex(speedGroId, hasAg) {
    if (hasAg === false) {
        switch (speedGroId) {
            case 0: 
                return 0;
            case 1: 
                return 1;
            case 2: 
                return 2;
            case 3: 
                return 3;
            default: 
                return 0;
        }
    } else if (hasAg === true){
        switch (speedGroId) {
            case 0: 
                return 1;
            case 1: 
                return 4;
            case 2: 
                return 5;
            case 3: 
                return 6;
            default: 
                return 0;
        }
    } 
    return -1;
};